import { Dropdown as BootstrapDropdown } from "react-bootstrap";

/**
 * Component has been deprecated and should not be used anymore.
 * @deprecated Use components from shared/ui instead
 */
const Dropdown = ({
  id,
  options,
  label,
  selectedValue,
  changeHandler = undefined,
  value,
  minWidth,
  className,
  ...props
}) => {
  return (
    <BootstrapDropdown className={className}>
      <BootstrapDropdown.Toggle id={id} style={{ minWidth: minWidth }}>
        {label}
        {selectedValue}
      </BootstrapDropdown.Toggle>
      <BootstrapDropdown.Menu style={{ maxHeight: "85vh", overflowY: "auto" }}>
        {options?.map(({ displayValue, optionValue }) => (
          <BootstrapDropdown.Item
            key={displayValue}
            value={optionValue}
            active={selectedValue === displayValue}
            onClick={() => changeHandler(optionValue)}
            {...props}
          >
            {displayValue}
          </BootstrapDropdown.Item>
        ))}
      </BootstrapDropdown.Menu>
    </BootstrapDropdown>
  );
};

export default Dropdown;
